import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { this.props.history } from 'react-router';
// import Moment from 'react-moment';
// import Pagination from "react-js-pagination";
import * as constant from '../../../constants/constant';
import validator from './../../common/validator.js';
import * as userActions from '../../../actions/admin/user/userActions.js';
import autoBind from 'auto-bind';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import * as SVGICONS from '../../../images/img/images';
import CheckBox from './checkBox';
// const items = ['admin', 'finance', 'feedback', 'vetting', 'specialistuser', 'photouser', 'patientuser', 'Specialist Assisstant']
class AddEdit extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			spinner: false,
			adminUserData: {},
			isEdit: false,
			image: { value: '', isValid: true, message: '' },
			gender: { value: 'Male', isValid: true, message: '' },
			userName: { value: '', isValid: true, message: '' },
			phoneNo: { value: '', isValid: true, message: '' },
			email: { value: '', isValid: true, message: '' },
			userId: '',
			userType: { value: '', isValid: true, message: '' },
			phoneNoCountryCode: { value: localStorage.getItem('calling_code')?localStorage.getItem('calling_code'):'', isValid: true, message: '' },
			items: [
				{ value: "admin", name: 'Admin', isChecked: false },
				{ value: "finance", name: 'Finance', isChecked: false },
				{ value: "feedback", name: 'Feedback', isChecked: false },
				{ value: "vetting", name: 'Vetting', isChecked: false },
				{ value: "specialistuser", name: 'Specialistuser', isChecked: false },
				{ value: "photouser", name: 'Photo User', isChecked: false },
				{ value: "patientuser", name: 'Patient User', isChecked: false },
				{ value: "specialistAssisstant", name: 'Specialist Assisstant', isChecked: false }
			]

		}

	}
	componentWillMount() {
		if (this.props.match.params.userId) {
			let userId = this.props.match.params.userId;
			this.props.actions.getUserById(userId);
		} else {
			console.log('in else')
			this.setState({
				phoneNo: { value: '', isValid: true, message: '' },
				description: { value: '', isValid: true, message: '' }
			})
		}
	}
	onChange(event) {
		var state = this.state;
		state[event.target.name].value = event.target.value;


		//validation code
		if (event.target.name == "userName") {
			if (event.target.value.length > 0) {
				if (!validator.isValidName(event.target.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please enter a valid name';
				} else {
					state[event.target.name].isValid = true;
					state.userName.message = '';
				}
			} else {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Name is Required';
			}
		}
		else if (event.target.name == "email") {
			if (event.target.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Not a valid email address';
					this.setState(state);
				} else {
					state[event.target.name].isValid = true;
					state[event.target.name].message = '';
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else if (event.target.name == "phoneNo") {
			if ((event.target.value).length == 0) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Phone number is required';
			} else if ((event.target.value).length > 10) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Max allowed length is 10';
			} else if (!validator.isOnlyNumber(event.target.value)) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Only numbers are allowed in phone number';
			} else if ((state.phoneNo.value).length < 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Min allowed length is 10';
			}
			else {
				state[event.target.name].isValid = true;
				state[event.target.name].message = ''
			}
		}

		this.setState(state);
	}
	resetValidationStates() {
		var state = this.state;

		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}


	addEditUser(event) {
		event.preventDefault();
		let state = this.state;
		let permissionData = state.items.filter(item => item.isChecked == true);
		if (permissionData.length == 0) {
			state.userType.isValid = false;
			state.userType.message = 'Please select user type';
			this.setState(state);
		}
		if (state.userName || !state.userName) {
			if (state.userName.value != undefined && state.userName.value != "") {
				if (!validator.isValidName(state.userName.value)) {
					state.userName.isValid = false;
					state.userName.message = 'Please enter a valid name';
					this.setState(state);
				} else {
					state.userName.isValid = true;
					state.userName.message = '';
					this.setState(state);
				}
			} else {
				state.userName.isValid = false;
				state.userName.message = 'Name is Required';
				this.setState(state);
			}
		} else {
			state.userName.isValid = false;
			state.userName.message = 'Name is Required';
			this.setState(state);
		}

		if (state.email || !state.email) {
			if ((state.email.value != undefined && state.email.value != "") || document.getElementById('email').value != '') {

				if (!validator.isEmail(state.email.value) && !validator.isEmail(document.getElementById('email').value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				} else {
					state.email.isValid = true;
					state.email.message = '';
					this.setState(state);
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else {
			state.email.isValid = false;
			state.email.message = 'Email address is required';
			this.setState(state);
		}

		if (state.phoneNo || !state.phoneNo) {

			if ((state.phoneNo.value == '' || state.phoneNo.value == undefined) && document.getElementById('phoneNo').value == '') {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Phone number is required';
			} else if ((state.phoneNo.value).length > 10 || document.getElementById('phoneNo').value.length > 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Max allowed length is 10';
			} else if ((state.phoneNo.value).length < 10 || document.getElementById('phoneNo').value.length > 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Min allowed length is 10';
			}
			else if (!validator.isOnlyNumber(state.phoneNo.value) || !validator.isOnlyNumber(document.getElementById('phoneNo').value)) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Only numbers are allowed in phone number';
			}
			else {
				state.phoneNo.isValid = true;
				state.phoneNo.message = ''
			}
		}


		if (this.state.userName.value != '' && this.state.phoneNo.value != '' && this.state.email.value != '' && (this.state.phoneNo.message == '' || this.state.phoneNo.message == undefined) && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.userName.message == '' || this.state.userName.message == undefined)
			&& (this.state.gender.message == '' || this.state.gender.message == undefined)
			&& (this.state.userType.message == '' || this.state.userType.message == undefined)
		) {
			let user = {
				userName: this.state.userName.value,
				gender: this.state.gender.value,
				phoneNo: this.state.phoneNo.value,
				email: this.state.email.value,
				phoneNoCountryCode: this.state.phoneNoCountryCode.value ? this.state.phoneNoCountryCode.value : '+91',
				permissionData: this.state.items
			}
			if (this.props.match.params.userId) {

				user.userId = this.props.match.params.userId;
				let helll0 = JSON.stringify(user);
				let parseuser = JSON.parse(helll0)
				this.props.actions.updateUser(user);
			} else {

				this.props.actions.addUser(user);
			}

		}
	}
	uploadAdminUserImage(event) {
		//To change the view immediately after uploading image 
		event.preventDefault();
		this.resetValidationStates();
		if (event.target.name == "image") {
			if (event.target.files.length > 0) {
				if (!validator.ImageValidateFormate(event.target.files[0])) {
					toast.error('Please choose following format jpeg, jpg, png, gif')
				} else if (!validator.fileValidateSize(event.target.files[0])) {
					toast.error('File size must be less than 10 MB.')

				} else {
					let reader = new FileReader();
					let file = event.target.files[0];
					this.setState({ image: { value: file } })
					reader.onloadend = () => {
						this.setState({
							file: file,
							imagePreviewUrl: reader.result
						});
					}

					reader.readAsDataURL(file);


					this.setState({ [event.target.name]: event.target.files[0] });
					let patientObj = {
						file: event.target.files[0],
						userId: localStorage.getItem('userId')
					}
					this.props.actions.uploadAdminUserImage(patientObj);
				}
			}

		}

	}
	handleCheckChieldElement(event) {
		let items = this.state.items

		items.forEach(item => {
			if (item.value === event.target.value)
				item.isChecked = event.target.checked
		})

		this.setState({ items: items })
	}
	componentWillReceiveProps(nextProps) {

		if (nextProps.userData && nextProps.userData.success && this.props.match.params.userId && !nextProps.adminUserUpdatedSuccess) {

			this.setState({
				isEdit: true,
				// oldFile: nextProps.userData.listImage,
				// file: { value: nextProps.userData.listImage ? '' : this.state.file.value, isValid: true, message: '' },
				userName: { value: nextProps.userData.userName ? nextProps.userData.userName : this.state.userName.value, isValid: true, message: '' },
				gender: { value: nextProps.userData.gender ? nextProps.userData.gender : this.state.gender.value, isValid: true, message: '' },
				phoneNo: { value: nextProps.userData.phoneNo ? nextProps.userData.phoneNo : this.state.phoneNo.value, isValid: true, message: '' },
				email: { value: nextProps.userData.email ? nextProps.userData.email : this.state.email.value, isValid: true, message: '' },
				phoneNoCountryCode: { value: nextProps.userData.phoneNoCountryCode ? nextProps.userData.phoneNoCountryCode : this.state.phoneNoCountryCode.value, isValid: true, message: '' },

				items: nextProps.userData.permission ? nextProps.userData.permission : this.state.items

			})
		}
		else if (nextProps.success && nextProps.adminUserData) {
			this.props.history.push(localStorage.getItem('urlLocation'));
			this.setState({
				spinner: false
			})
		} else if ((nextProps.adminUserUpdatedData && nextProps.adminUserUpdatedSuccess)) {
			this.props.history.push(localStorage.getItem('urlLocation'));
			this.setState({
				spinner: false
			})
		} else {
			this.setState({
				spinner: false
			})
		}
	}

	render() {
		var image = this.state.imageCopy ? this.state.imageCopy : constant.DEFAULT_USER_IMAGE;
		let { imagePreviewUrl } = this.state;
		let $imagePreview = null;
		if (!imagePreviewUrl) {
			var folderName = (image == constant.DEFAULT_USER_IMAGE) ? constant.COMMON_FOLDER : constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/';
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + folderName + image;
		}
		var bloodGroupList = this.state.bloodGroupList;
		var countryCodeList = constant.PHONENOCOUNTRYCODE ? constant.PHONENOCOUNTRYCODE : [];
		return (
			<div className="content-wrapper">
				<section className="content container-fluid">
					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li><Link to="#tab_1" data-toggle="tab" className="active show">{this.props.match.params.userId ? 'Edit User' : 'Add User'}</Link></li>
									</ul>

									<div className="tab-content">
										<div className="tab-pane active" id="tab_1">
											<div className="settingInput">
												{/* {this.state.isEdit ? < div className="row">
													<div className="col-md-12">		<form name="uploadimage" >
														<div className="userProImg" style={{ "width": 117 }}>
															<img src={imagePreviewUrl} />
															<input type="file" style={{ "display": "none" }} className="form-control" ref="file" name="image" id="fileID" onChange={this.uploadAdminUserImage} style={{ 'display': 'none' }} />
															<label htmlFor="fileID" style={{ 'cursor': 'pointer' }}>
																<SVGICONS.SpecialistProfileSvg />

															</label>
														</div>
													</form>
													</div>
												</div> : ''} */}

												<form>
													<div className="row">
														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="text" name="userName" value={this.state.userName ? this.state.userName.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter Name" />
																</div>
																<span className="help-block">{this.state.userName.message}</span>
															</div>
														</div>

														<div className="col-md-6">
															<div className="boxMrgB">

																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/email_input_icon.svg')} alt="" /></i></span>

																	<input type="text" id="email" name="email" onChange={this.onChange} value={this.state.email ? this.state.email.value : ''} className="form-control" placeholder="Enter Email" />
																</div>
																<span className="help-block">{this.state.email.message}</span>
															</div>
														</div>

														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/phone_input_icon.svg')} alt="" /></i></span>


																	<div className="dropdown cusmobile">
																		<select className="form-control" style={{ border: 0 }} name="phoneNoCountryCode" value={this.state.phoneNoCountryCode ? this.state.phoneNoCountryCode.value : '+91'} onChange={this.onChange.bind(this)} >
																			{(countryCodeList && countryCodeList.length) > 0 ? countryCodeList.map((option, index) => <option value={option} key={index}>{option}</option>) : ''}
																		</select>
																	</div>

																	<input id="phoneNo" style={{ marginLeft: 20 }} type="text" value={this.state.phoneNo ? this.state.phoneNo.value : ''} name="phoneNo" onChange={this.onChange} className="form-control p-d-20" placeholder="Phone Number" />

																</div>
																<span className="help-block">{this.state.phoneNo.message}</span>
															</div>
														</div>

														<div className="col-md-6">
															<div className="row">
																<div className="col-md-2">
																	<div className="genderInfo ">Gender</div>
																</div>
																<div className="col-md-4">
																	<div className="boxMrgB boxMrgT">
																		<div className="radio radio-primary">
																			<input type="radio" onChange={this.onChange} name="gender" id="gender1" value="Male" checked={this.state.gender.value === 'Male'} />
																			<label htmlFor="gender1"> Male </label>
																		</div>
																	</div>
																</div>
																<div className="col-md-4">
																	<div className="boxMrgB boxMrgT">
																		<div className="radio radio-primary">
																			<input type="radio" name="gender" id="gender2" onChange={this.onChange} value="Female" checked={this.state.gender.value === 'Female'} />
																			<label htmlFor="gender2"> Female </label>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="container">
															<div className="row">
																<div className="col-sm-3">
																	<div className="genderInfo usertype ">User Type</div>
																</div>


															</div>
														</div>
														<div className="container">
															<div className="row">

																{
																	this.state.items.map(item => {
																		
																		return (<div className="col-sm-3 checkboxspace"><CheckBox handleCheckChieldElement={this.handleCheckChieldElement} {...item} /></div>)
																	})
																}

																<span className="help-block">{this.state.userType.message}</span>
															</div>
														</div>

														<div className="col-md-12 text-center">
															<div className="bottomBtn">
																<button type="button" onClick={this.addEditUser} className="btn btn-warning btn-lg" >{this.props.match.params.userId ? 'Update' : 'Save'} {this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
															</div>
														</div>
													</div>

												</form>
											</div>
										</div>


									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div >

		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		adminUserData: state.adminUser.adminUserData ? state.adminUser.adminUserData : {},
		success: state.adminUser.adminUserData ? state.adminUser.adminUserData.success : false,
		userData: state.adminUser.userData ? state.adminUser.userData : {},
		userDataSuccess: state.adminUser.userData ? state.adminUser.userData.success : false,
		adminUserUpdatedData: state.adminUser.adminUserUpdatedData ? state.adminUser.adminUserUpdatedData : {},
		adminUserUpdatedSuccess: state.adminUser.adminUserUpdatedData ? state.adminUser.adminUserUpdatedData.success : false,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(userActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(AddEdit);